/* ============================================================
   LISTICLE PAGE JS
   - FAQ accordions
   - Scroll reveal animations
   ============================================================ */
(function() {
  'use strict';

  /* ---------- FAQ ACCORDIONS ---------- */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.ns-listicle-faq__trigger');
    if (!trigger) return;
    var item = trigger.closest('.ns-listicle-faq__item');
    var answer = item.querySelector('.ns-listicle-faq__answer');
    var isOpen = item.classList.contains('is-open');

    // Close all others
    document.querySelectorAll('.ns-listicle-faq__item.is-open').forEach(function(openItem) {
      if (openItem !== item) {
        openItem.classList.remove('is-open');
        openItem.querySelector('.ns-listicle-faq__answer').style.maxHeight = '0';
      }
    });

    if (isOpen) {
      item.classList.remove('is-open');
      answer.style.maxHeight = '0';
    } else {
      item.classList.add('is-open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  });

  /* ---------- SCROLL REVEAL ---------- */
  var reveals = document.querySelectorAll('.ns-listicle-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    reveals.forEach(function(el) { observer.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('is-visible'); });
  }
})();
